module.exports = __webpack_public_path__ + "static/media/energy6.8d6a7ee9.jpg";